var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_5968908",
    clipPath: "url(#clip0_5191_13317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "#FF4500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.8304 12.5003C20.8304 11.4935 20.0143 10.6774 19.0075 10.6774C18.5161 10.6774 18.071 10.8728 17.7432 11.1889C16.4972 10.2897 14.7804 9.70903 12.8682 9.64229L13.6986 5.7355L16.4116 6.31226C16.4446 7.002 17.0096 7.55244 17.7075 7.55244C18.4266 7.55244 19.0096 6.96948 19.0096 6.25034C19.0096 5.5312 18.4266 4.94824 17.7075 4.94824C17.1959 4.94824 16.7578 5.2459 16.5449 5.675L13.5155 5.03105C13.4312 5.01274 13.3429 5.0293 13.2706 5.07646C13.1981 5.12354 13.1474 5.19741 13.1294 5.28184L12.2021 9.64116C10.2618 9.69502 8.51753 10.2765 7.25547 11.1857C6.92798 10.8716 6.48442 10.6775 5.99478 10.6775C4.98804 10.6775 4.17188 11.4937 4.17188 12.5004C4.17188 13.2411 4.6144 13.8773 5.24893 14.1625C5.2208 14.3438 5.20542 14.5275 5.20542 14.7139C5.20542 17.5185 8.47002 19.792 12.4971 19.792C16.5241 19.792 19.7887 17.5185 19.7887 14.7139C19.7887 14.5288 19.7736 14.3461 19.7458 14.1662C20.3845 13.8825 20.8304 13.244 20.8304 12.5003ZM8.33247 13.8025C8.33247 13.0845 8.91685 12.5003 9.63511 12.5003C10.3527 12.5003 10.9366 13.0845 10.9366 13.8025C10.9366 14.5203 10.3527 15.1043 9.63511 15.1043C8.91685 15.1043 8.33247 14.5203 8.33247 13.8025ZM15.593 17.2431C14.7042 18.1306 13.0014 18.1996 12.5006 18.1996C11.9998 18.1996 10.2967 18.1306 9.40913 17.2429C9.27739 17.1112 9.27739 16.8975 9.40923 16.7657C9.54092 16.634 9.75464 16.634 9.88643 16.7658C10.4465 17.3259 11.6448 17.5247 12.5006 17.5247C13.3565 17.5247 14.555 17.3259 15.1161 16.7656C15.2481 16.634 15.4617 16.6342 15.5933 16.7659C15.7249 16.8978 15.7249 17.1115 15.593 17.2431ZM15.3637 15.1047C14.6458 15.1047 14.0616 14.5206 14.0616 13.8027C14.0616 13.0846 14.6458 12.5003 15.3637 12.5003C16.0817 12.5003 16.6658 13.0846 16.6658 13.8027C16.6658 14.5206 16.0816 15.1047 15.3637 15.1047Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5191_13317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.493c88361120fe2615f03da15eedac33.svg";
export { ForwardRef as ReactComponent };